<template>
   <div>
        <div class="table-wrapper on-991" v-if="$i18n.locale=='en'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td colspan="8" class="white center bolder font">31 DECEMBER 2019</td>
                        </tr>
                        <tr class="med-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td class="white bolder font">KUWAIT</td>
                            <td class="white bolder font">JORDAN</td>
                            <td class="white bolder font">SUDAN</td>
                            <td class="white bolder font">IRAQ</td>
                            <td class="white bolder font">BAHRAIN</td>
                            <td class="white bolder font">KSA</td>
                            <td class="white bolder font">OTHERS</td>
                            <td class="white bolder font">TOTAL</td>
                        </tr>
                        <tr class="light-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td colspan="8" class="white center bolder font">KD ’000</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="font skyBlue">Segment revenues
                                <br/> <span class="font">– airtime, data & subscriptions (Over time)</span></td>
                            <td class="font">258,718</td>
                            <td class="font">144,555</td>
                            <td class="font">91,726</td>
                            <td class="font">325,819</td>
                            <td class="font">40,719</td>
                            <td class="font">586,822</td>
                            <td class="font">26,669</td>
                            <td class="font">1,475,028</td>
                        </tr>
                        <tr>
                            <td class="font skyBlue">Segment revenues
                                <br/> <span class="font">- trading income <br>(Point in time)</span></td>
                            <td class="font">74,733</td>
                            <td class="font">6,089</td>
                            <td class="font">628</td>
                            <td class="font">1,348</td>
                            <td class="font">9,925</td>
                            <td class="font">93,065 </td>
                            <td class="font">74</td>
                            <td class="font">185,862</td>
                        </tr>
                        <tr>
                            <td class="font skyBlue">Net profit before interest and tax</td>
                            <td class="font">83,299</td>
                            <td class="font">37,595</td>
                            <td class="font">19,988</td>
                            <td class="font">47,658</td>
                            <td class="font">4,969</td>
                            <td class="font">121,873</td>
                            <td class="font">10,834</td>
                            <td class="font">326,216</td>
                        </tr>
                        <tr>
                            <td class="font">Interest income</td>
                            <td class="font">269</td>
                            <td class="font">338</td>
                            <td class="font">1,061</td>
                            <td class="font">1,322</td>
                            <td class="font">230</td>
                            <td class="font">2,135</td>
                            <td class="font">418</td>
                            <td class="font">5,773</td>
                        </tr>
                        <tr>
                            <td class="font">Finance costs</td>
                            <td class="font">(406)</td>
                            <td class="font">(7,216)</td>
                            <td class="font">(258)</td>
                            <td class="font">(18,345)</td>
                            <td class="font">(956)</td>
                            <td class="font">(84,680)</td>
                            <td class="font">(99)</td>
                            <td class="font">(111,960)</td>
                        </tr>
                        <tr>
                            <td class="font">Income tax expenses</td>
                            <td class="font">-</td>
                            <td class="font">(7,441)</td>
                            <td class="font">(5,801)</td>
                            <td class="font">(10,335)</td>
                            <td class="font">-</td>
                            <td class="font">-</td>
                            <td class="font">(1,934)</td>
                            <td class="font">(25,511)</td>
                        </tr>
                        <tr class="dark-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td class="font white bold">83,162</td>
                            <td class="font white bold">23,276</td>
                            <td class="font white bold">14,990</td>
                            <td class="font white bold">20,300</td>
                            <td class="font white bold">4,243</td>
                            <td class="font white bold">39,328</td>
                            <td class="font white bold">9,219</td>
                            <td class="font white bold">194,518</td>
                        </tr>
                        <tr>
                            <td class="font skyBlue">Unallocated items:</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                        </tr>
                        <tr>
                            <td class="font">Investment income</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td class="font">1,007</td>
                        </tr>
                        <tr>
                            <td class="font">Share of results of associates and joint venture</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td class="font">2,762</td>
                        </tr>
                        <tr>
                            <td class="font">Others (including unallocated interest income, income tax and finance costs)</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td class="font">50,262</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font white">Profit for the year</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="font white">248,549</td>
                        </tr>
                        <tr>
                            <td class="font skyBlue">Segment assets including allocated goodwill</td>
                            <td class="font">392,323</td>
                            <td class="font">296,926</td>
                            <td class="font">139,436</td>
                            <td class="font">1,055,385</td>
                            <td class="font">87,195 </td>
                            <td class="font">2,179,487</td>
                            <td class="font">63,345</td>
                            <td class="font">4,214,097</td>
                        </tr>
                        <tr>
                            <td class="font">ROU asset</td>
                            <td class="font">6,495</td>
                            <td class="font">16,691</td>
                            <td class="font">1,589</td>
                            <td class="font">30,746</td>
                            <td class="font">8,187</td>
                            <td class="font">117,211</td>
                            <td class="font">133</td>
                            <td class="font">181,052</td>
                        </tr>
                        <tr>
                            <td class="font">Unallocated items:</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                        </tr>
                        <tr>
                            <td class="font">Investment securities at FVTPL</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td class="font">8,540</td>
                        </tr>
                        <tr>
                            <td class="font">Investment securities at FVOCI </td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td class="font">6,360</td>
                        </tr>
                        <tr>
                            <td class="font">Investment in associates and joint venture</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td class="font">72,612</td>
                        </tr>
                        <tr>
                            <td class="font">Others (net of eliminations)</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td class="font">253,432</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font white">Consolidated assets </td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="font white">4,736,093</td>
                        </tr>
                        <tr>
                            <td class="font skyBlue">Segment liabilities</td>
                            <td class="font">134,469</td>
                            <td class="font">119,608</td>
                            <td class="font">41,063</td>
                            <td class="font">214,818</td>
                            <td class="font">26,773</td>
                            <td class="font">1,257,750</td>
                            <td class="font">66,161</td>
                            <td class="font">1,860,642</td>
                        </tr>
                        <tr>
                            <td class="font">Lease liabilities (Current & non-current)</td>
                            <td class="font">5,911</td>
                            <td class="font">16,793</td>
                            <td class="font">1,607</td>
                            <td class="font">34,668</td>
                            <td class="font">8,498</td>
                            <td class="font">119,456</td>
                            <td class="font">140</td>
                            <td class="font">187,073</td>
                        </tr>
                        <tr>
                            <td class="font">Due to banks</td>
                            <td class="font">-</td>
                            <td class="font">6,622</td>
                            <td class="font">1,785</td>
                            <td class="font">168,387</td>
                            <td class="font">-</td>
                            <td class="font">542,804</td>
                            <td class="font">11</td>
                            <td class="font">719,609</td>
                        </tr>
                        <tr class="dark-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td class="font white bold">140,380</td>
                            <td class="font white bold">143,023</td>
                            <td class="font white bold">44,455</td>
                            <td class="font white bold">417,873</td>
                            <td class="font white bold">35,271</td>
                            <td class="font white bold">1,920,010</td>
                            <td class="font white bold">66,312</td>
                            <td class="font white bold">2,767,324</td>
                        </tr>
                        <tr>
                            <td class="font skyBlue">Unallocated items:</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                        </tr>
                    </tbody>
                    <tr>
                        <td class="font">Due to banks</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td class="font">679,115</td>
                    </tr>
                    <tr>
                        <td class="font">Others (net of eliminations)</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td class="font">(388,945)</td>
                    </tr>
                    <tr class="dark-gray">
                        <td class="font white">Consolidated liabilities</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="font white">3,057,494</td>
                    </tr>
                    <tr class="dark-gray">
                        <td class="font white">Net consolidated assets</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="font white">1,678,599</td>
                    </tr>
                    <tr>
                        <td class="font">Capital expenditure incurred during the year</td>
                        <td class="font">65,998</td>
                        <td class="font">15,309</td>
                        <td class="font">15,578</td>
                        <td class="font">40,376</td>
                        <td class="font">16,234</td>
                        <td class="font">154,580</td>
                        <td class="font">6,000</td>
                        <td class="font">314,075</td>
                    </tr>
                    <tr>
                        <td class="font">Unallocated (net of eliminations)</td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td class="font">(1,898)</td>
                    </tr>
                    <tr class="dark-gray">
                        <td class="font white">Total capital expenditure</td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td class="font white">312,177</td>
                    </tr>
                    <tr>
                        <td class="font">Depreciation and amortization</td>
                        <td class="font">35,357</td>
                        <td class="font">24,792</td>
                        <td class="font">8,087</td>
                        <td class="font">77,628</td>
                        <td class="font">8,642</td>
                        <td class="font">154,427</td>
                        <td class="font">10,477</td>
                        <td class="font">319,410</td>
                    </tr>
                    <tr>
                        <td class="font">Amortization of ROU assets</td>
                        <td class="font">3,461</td>
                        <td class="font">3,231 </td>
                        <td class="font">185</td>
                        <td class="font">6,975</td>
                        <td class="font">3,144</td>
                        <td class="font">32,981 </td>
                        <td class="font">860</td>
                        <td class="font">50,837</td>
                    </tr>
                    <tr>
                        <td class="font">Unallocated </td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td class="font">5,707</td>
                    </tr>
                    <tr class="dark-gray">
                        <td class="font white">Total depreciation and amortization</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="font white">375,954</td>
                    </tr>
                </table>
            </div>
        </div>

        <!--Arabic-->
        
        <div class="table-wrapper on-991" v-if="$i18n.locale=='ar'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td colspan="8" class="white center bolder font">31 ديسمبر 2019</td>
                        </tr>
                        <tr class="med-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td class="white bolder font">الكويت</td>
                            <td class="white bolder font">الأردن</td>
                            <td class="white bolder font">السودان</td>
                            <td class="white bolder font">العراق</td>
                            <td class="white bolder font">البحرين</td>
                            <td class="white bolder font">السعودية</td>
                            <td class="white bolder font">أخرى</td>
                            <td class="white bolder font">المجموع</td>
                        </tr>
                        <tr class="light-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td colspan="8" class="white center bolder font">ألف دينار كويتي</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="font skyBlue">إيرادات القطاع
                                <br/> <span class="font">_ مكالمات وبيانات واشتراكات<br/>(مع مرور الوقت)</span></td>
                            <td class="font">258,718</td>
                            <td class="font">144,555</td>
                            <td class="font">91,726</td>
                            <td class="font">325,819</td>
                            <td class="font">40,719</td>
                            <td class="font">586,822</td>
                            <td class="font">26,669</td>
                            <td class="font">1,475,028</td>
                        </tr>
                        <tr>
                            <td class="font skyBlue">إيرادات القطاع
                                <br/> <span class="font">_ إيرادات المتاجرة(عند نقطة زمنية محددة)</span></td>
                            <td class="font">74,733</td>
                            <td class="font">6,089</td>
                            <td class="font">628</td>
                            <td class="font">1,348</td>
                            <td class="font">9,925</td>
                            <td class="font">93,065 </td>
                            <td class="font">74</td>
                            <td class="font">185,862</td>
                        </tr>
                        <tr>
                            <td class="font skyBlue">صافي الربح قبل الفوائد والضرائب</td>
                            <td class="font">83,299</td>
                            <td class="font">37,595</td>
                            <td class="font">19,988</td>
                            <td class="font">47,658</td>
                            <td class="font">4,969</td>
                            <td class="font">121,873</td>
                            <td class="font">10,834</td>
                            <td class="font">326,216</td>
                        </tr>
                        <tr>
                            <td class="font">إيرادات فوائد</td>
                            <td class="font">269</td>
                            <td class="font">338</td>
                            <td class="font">1,061</td>
                            <td class="font">1,322</td>
                            <td class="font">230</td>
                            <td class="font">2,135</td>
                            <td class="font">418</td>
                            <td class="font">5,773</td>
                        </tr>
                        <tr>
                            <td class="font">أعباء تمويل</td>
                            <td class="font">(406)</td>
                            <td class="font">(7,216)</td>
                            <td class="font">(258)</td>
                            <td class="font">(18,345)</td>
                            <td class="font">(956)</td>
                            <td class="font">(84,680)</td>
                            <td class="font">(99)</td>
                            <td class="font">(111,960)</td>
                        </tr>
                        <tr>
                            <td class="font">مصاريف ضريبة الدخل</td>
                            <td class="font">-</td>
                            <td class="font">(7,441)</td>
                            <td class="font">(5,801)</td>
                            <td class="font">(10,335)</td>
                            <td class="font">-</td>
                            <td class="font">-</td>
                            <td class="font">(1,934)</td>
                            <td class="font">(25,511)</td>
                        </tr>
                        <tr class="dark-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td class="font white bold">83,162</td>
                            <td class="font white bold">23,276</td>
                            <td class="font white bold">14,990</td>
                            <td class="font white bold">20,300</td>
                            <td class="font white bold">4,243</td>
                            <td class="font white bold">39,328</td>
                            <td class="font white bold">9,219</td>
                            <td class="font white bold">194,518</td>
                        </tr>
                        <tr>
                            <td class="font skyBlue">بنود غير موزعة:</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                        </tr>
                        <tr>
                            <td class="font">إيرادات استثمارات</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td class="font">1,007</td>
                        </tr>
                        <tr>
                            <td class="font">حصة في نتائج شركات زميلة ومشروع مشترك</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td class="font">2,762</td>
                        </tr>
                        <tr>
                            <td class="font">أخرى (تتضمن إيرادات فوائد وضريبة<br/>دخل وأعباء تمويل غير موزعة، بالصافي<br/> من استبعادات)</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td class="font">50,262</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font white">ربح السنة</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="font white">248,549</td>
                        </tr>
                        <tr>
                            <td class="font skyBlue">موجودات القطاع بما في ذلك<br/>الشهرة الموزعة</td>
                            <td class="font">392,323</td>
                            <td class="font">296,926</td>
                            <td class="font">139,436</td>
                            <td class="font">1,055,385</td>
                            <td class="font">87,195 </td>
                            <td class="font">2,179,487</td>
                            <td class="font">63,345</td>
                            <td class="font">4,214,097</td>
                        </tr>
                        <tr>
                            <td class="font">أًصول حق الاستخدام</td>
                            <td class="font">6,495</td>
                            <td class="font">16,691</td>
                            <td class="font">1,589</td>
                            <td class="font">30,746</td>
                            <td class="font">8,187</td>
                            <td class="font">117,211</td>
                            <td class="font">133</td>
                            <td class="font">181,052</td>
                        </tr>
                        <tr>
                            <td class="font">بنود غير موزعة:</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                        </tr>
                        <tr>
                            <td class="font">استثمارات في أوراق مالية بالقيمة العادلة من<br/>خلال بيان الربح أو الخسارة</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td class="font">8,540</td>
                        </tr>
                        <tr>
                            <td class="font">استثمارات في أوراق مالية بالقيمة العادلة من<br/>خلال الدخل الشامل الآخر</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td class="font">6,360</td>
                        </tr>
                        <tr>
                            <td class="font">استثمارات في شركات زميلة ومشروع مشترك</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td class="font">72,612</td>
                        </tr>
                        <tr>
                            <td class="font">أخرى (بالصافي من استبعادات)</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td class="font">253,432</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font white">الموجودات المجمعة</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="font white">4,736,093</td>
                        </tr>
                        <tr>
                            <td class="font skyBlue">مطلوبات القطاع</td>
                            <td class="font">134,469</td>
                            <td class="font">119,608</td>
                            <td class="font">41,063</td>
                            <td class="font">214,818</td>
                            <td class="font">26,773</td>
                            <td class="font">1,257,750</td>
                            <td class="font">66,161</td>
                            <td class="font">1,860,642</td>
                        </tr>
                        <tr>
                            <td class="font">التزامات عقد إيجار (متداولة وغير متداولة)</td>
                            <td class="font">5,911</td>
                            <td class="font">16,793</td>
                            <td class="font">1,607</td>
                            <td class="font">34,668</td>
                            <td class="font">8,498</td>
                            <td class="font">119,456</td>
                            <td class="font">140</td>
                            <td class="font">187,073</td>
                        </tr>
                        <tr>
                            <td class="font">مستحق لبنوك</td>
                            <td class="font">-</td>
                            <td class="font">6,622</td>
                            <td class="font">1,785</td>
                            <td class="font">168,387</td>
                            <td class="font">-</td>
                            <td class="font">542,804</td>
                            <td class="font">11</td>
                            <td class="font">719,609</td>
                        </tr>
                        <tr class="dark-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td class="font white bold">140,380</td>
                            <td class="font white bold">143,023</td>
                            <td class="font white bold">44,455</td>
                            <td class="font white bold">417,873</td>
                            <td class="font white bold">35,271</td>
                            <td class="font white bold">1,920,010</td>
                            <td class="font white bold">66,312</td>
                            <td class="font white bold">2,767,324</td>
                        </tr>
                        <tr>
                            <td class="font skyBlue">بنود غير موزعة:</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                        </tr>
                    </tbody>
                    <tr>
                        <td class="font">مستحق لبنوك</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td class="font">679,115</td>
                    </tr>
                    <tr>
                        <td class="font">أخرى (بالصافي من استبعادات)</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td class="font">(388,945)</td>
                    </tr>
                    <tr class="dark-gray">
                        <td class="font white">المطلوبات المجمعة</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="font white">3,057,494</td>
                    </tr>
                    <tr class="dark-gray">
                        <td class="font white">صافي الموجودات المجمعة</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="font white">1,678,599</td>
                    </tr>
                    <tr>
                        <td class="font">نفقات رأسمالية متكبدة خلال السنة</td>
                        <td class="font">65,998</td>
                        <td class="font">15,309</td>
                        <td class="font">15,578</td>
                        <td class="font">40,376</td>
                        <td class="font">16,234</td>
                        <td class="font">154,580</td>
                        <td class="font">6,000</td>
                        <td class="font">314,075</td>
                    </tr>
                    <tr>
                        <td class="font">غير موزعة (بالصافي من استبعادات)</td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td class="font">(1,898)</td>
                    </tr>
                    <tr class="dark-gray">
                        <td class="font white">إجمالي النفقات الرأسمالية</td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td class="font white">312,177</td>
                    </tr>
                    <tr>
                        <td class="font">استهلاكات وإطفاءات</td>
                        <td class="font">35,357</td>
                        <td class="font">24,792</td>
                        <td class="font">8,087</td>
                        <td class="font">77,628</td>
                        <td class="font">8,642</td>
                        <td class="font">154,427</td>
                        <td class="font">10,477</td>
                        <td class="font">319,410</td>
                    </tr>
                    <tr>
                        <td class="font">إطفاء أصول حق الاستخدام</td>
                        <td class="font">3,461</td>
                        <td class="font">3,231 </td>
                        <td class="font">185</td>
                        <td class="font">6,975</td>
                        <td class="font">3,144</td>
                        <td class="font">32,981 </td>
                        <td class="font">860</td>
                        <td class="font">50,837</td>
                    </tr>
                    <tr>
                        <td class="font">غير موزعة</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td class="font">5,707</td>
                    </tr>
                    <tr class="dark-gray">
                        <td class="font white">مجموع الاستهلاكات والإطفاءات</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="font white">375,954</td>
                    </tr>
                </table>
            </div>
        </div>
   </div>
</template>

<script>
export default {

}
</script>

<style>

</style>